export enum EAddressValidationType {
  None = 'none',
  Loose = 'loose',
  LooseWithoutHouseNumber = 'looseWithoutHouseNumber',
  Strict = 'strict',
}
